module.exports = __webpack_public_path__ + "img/HOMECREDIT.b7dfa032.svg";